/*
 * @Author: twy+1-at-831623936441 ISfIgyagCK159zOXbALBCYfPJsXX7JI+UcjxsoGvWhTuiwzjxNFOeYUELbg=
 * @Date: 2025-07-04 09:31:16
 * @LastEditors: twy+1-at-831623936441 ISfIgyagCK159zOXbALBCYfPJsXX7JI+UcjxsoGvWhTuiwzjxNFOeYUELbg=
 * @LastEditTime: 2025-07-10 10:57:45
 * @FilePath: \gptsEn_new\src\api\login.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from '@/utils/request'
// 手机号验证码获取
export function getsms(params) {
  return request({
    url: '/sms/sendSms',
    method: 'get',
    params
  })
}
// 邮箱验证码获取
export function getemail(data) {
  return request({
    url: '/mail/sendMail',
    method: 'post',
     data: { email: data.email }  // 使用data传递
  })
}
// 短信登录功能
export function loginsms(data) {
  return request({
    url: '/info/gpts_user/loginBySms',
    method: 'post',
    data
  })
}
// 邮箱登录功能
export function loginemail(data) {
  return request({
    url: '/info/gpts_user/loginByEmail',
    method: 'post',
    data
  })
}
// 退出登录
export function loginout(params) {
  // 从 localStorage 获取 token
  const token = localStorage.getItem('token');
  console.log('登出时使用的token:', token); // 调试
  return request({
    url: '/info/gpts_user/logout',
    method: 'post',
    params,
    headers: {
      'Authorization': `Bearer ${token}`  // 添加 Authorization 头
    }
  }).finally(() => {
    localStorage.removeItem('token')
    localStorage.removeItem('gptsUserId')
    localStorage.removeItem('gptsUserName')
  })
}
// 根据用户id获取用户的信息
export function getUserInfo(userId) {
  return request({
    url: `/info/gpts_user/${userId}`,
    method: 'get',
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`, // 从localStorage获取token
      'Content-Type': 'application/json'
    }
  })
}
//提交用户信息
export function submitUserInfo(data) {
  return request({
    url: '/info/gpts_user',
    method: 'put',
    data,
    headers:{
            'Authorization': `Bearer ${localStorage.getItem('token')}`, // 从localStorage获取token
      'Content-Type': 'application/json'
    }
  })
}

// 手机号绑定
export function bindPhone1(data) {
  return request({
    url: '/info/gpts_user/bind-phone',
    method: 'post',
    data,
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`, // 从localStorage获取token
      'Content-Type': 'application/json'
    }
  })
}
// 手机号换绑
export function changePhone(data) {
  return request({
    url: '/info/gpts_user/change-phone',
    method: 'post',
    data,
        headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`, // 从localStorage获取token
      'Content-Type': 'application/json'
    }
  })
}
// 邮箱绑定
export function bindEmail(data) {
  return request({
    url: '/info/gpts_user/bind-email',
    method: 'post',
    data,
        headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`, // 从localStorage获取token
      'Content-Type': 'application/json'
    }
  })
}
// 邮箱换绑
export function changeEmail(data) {
  return request({
    url: '/info/gpts_user/change-email',
    method: 'post',
    data,
        headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`, // 从localStorage获取token
      'Content-Type': 'application/json'
    }
  })
}